import styled, { css } from 'styled-components';

export const Background = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 102;
  ${(props) =>
    !props.view &&
    css`
      visibility: hidden;
    `}
`;

export const Wrap = styled.div`
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  ${(props) =>
    props.view
      ? css`
          //height: 181px;
          height: 330px;
        `
      : css`
          height: 0;
        `};
  will-change: height;
  transition: height 0.5s;
`;

export const Header = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
  h3 {
    font-size: 18px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: 58px;
  width: 58px;
  background: url('/images/btn-close.svg') no-repeat center center;
  background-size: 18px;
`;

export const Buttons = styled.div`
  display: flex;
  height: 123px;
  > div {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    > button {
      font-size: 12px;
      :before {
        content: '';
        width: 40px;
        height: 40px;
        display: block;
        margin-bottom: 11px;
        background-size: 40px;
      }
      &.real {
        :before {
          background-image: url('/images/ic-real.svg');
        }
      }
      &.fake {
        :before {
          background-image: url('/images/ic-fake.svg');
        }
      }
      &.declare {
        :before {
          background-image: url('/images/ic-declare.svg');
        }
      }
      &.black {
        :before {
          background-image: url('/images/ic-black.svg');
        }
      }
      &.opacity {
        opacity: 0.2;
      }
    }
  }
`;

export const CommentForm = styled.form`
  padding: 14px 10px 12px;
  box-sizing: border-box;
  border-top: 1px solid #f5f5f5;
  position: relative;
`;

export const Content = styled.div`
  > p {
    color: #ccc;
    margin-bottom: 2px;
  }
  > div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  padding: 0 10px;
`;

export const CommentLabel = styled.label`
  background-color: #f5f5f5;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 6px;
  > div {
    padding: 0 20px;
    height: 30px;
    display: flex;
    align-items: center;
  }
  > input {
    width: 100%;
    padding: 0 50px 0 20px;
    height: 48px;
    border: none;
    box-sizing: border-box;
    background-color: #f8f8f8;
  }
`;

export const SubmitButton = styled.button`
  position: absolute;
  right: 20px;
  bottom: 12px;
  width: 50px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  :after {
    display: flex;
    content: '';
    width: 20px;
    height: 16px;
    background: url('/images/sp_layout.png') no-repeat -250px -165px;
    background-size: 350px 350px;
  }
  ${(props) =>
    props.isActive &&
    css`
      :after {
        background: url('/images/sp_layout.png') no-repeat -275px -165px;
        background-size: 350px 350px;
      }
    `}
`;
